// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.equipmentItem__iMQDY {
  min-height: 125px;
  max-width: 320px;
  width: 100%;
  padding: 15px;
  display: flex;
  flex-direction: column;
  background-color: var(--tables-primary-row-surface-default);
  position: relative;
  justify-content: space-between;
  box-shadow: var(--basic-box-shadow);
}

.deactivated__Ryvix {
  background: var(--inputs-disable-disable-surface);
}

.equipmentTitle__HXGbI {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  column-gap: 5px;
}

.equipmentItemName__da7Uo {
  font-size: 14px;
  font-weight: 500;
  line-height: 14px;
  color: var(--tables-primary-row-text-main);
  margin-bottom: 15px;
  text-transform: uppercase;
  text-decoration: none;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -moz-box;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  line-clamp: 2;
  box-orient: vertical;
  min-height: 34px;
  cursor: pointer;
}

.equipmentItemSensors__jtP2K {
  width: 100%;
  min-height: 37px;
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  position: relative;
  margin-bottom: auto;
}

.equipmentItemInfo__HvCXT {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-top: 15px;
}

.equipmentItemInfoAi__nrNvc {
  font-size: 11px;
  line-height: 14px;
  color: var(--tables-secondary-row-sub-title-text);
  display: flex;
  align-items: flex-end;
  text-transform: uppercase;
  gap: 5px;
}

.linkDetails__m5p6V {
  font-size: 12px;
  font-weight: 500;
  line-height: 14px;
  color: var(--buttons-surface);
  text-decoration: none;
  text-transform: uppercase;
}`, "",{"version":3,"sources":["webpack://./../src/pages/Sensors/components/SensorsEquipmentItem/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,iBAAA;EACA,gBAAA;EACA,WAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,2DAAA;EACA,kBAAA;EACA,8BAAA;EACA,mCAAA;AAzEF;;AA4EA;EACE,iDAAA;AAzEF;;AA4EA;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,eAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,0CAAA;EACA,mBAAA;EACA,yBAAA;EACA,qBAAA;EACA,gBAAA;EACA,uBAAA;EACA,iBAAA;EAEA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,aAAA;EACA,oBAAA;EACA,gBAAA;EACA,eAAA;AAzEF;;AA4EA;EACE,WAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;AAzEF;;AA4EA;EACE,WAAA;EACA,aAAA;EACA,8BAAA;EACA,qBAAA;EACA,gBAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,iBAAA;EACA,iDAAA;EACA,aAAA;EACA,qBAAA;EACA,yBAAA;EACA,QAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,6BAAA;EACA,qBAAA;EACA,yBAAA;AAzEF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.equipmentItem {\n  min-height: 125px;\n  max-width: 320px;\n  width: 100%;\n  padding: 15px;\n  display: flex;\n  flex-direction: column;\n  background-color: var(--tables-primary-row-surface-default);\n  position: relative;\n  justify-content: space-between;\n  box-shadow: var(--basic-box-shadow);\n}\n\n.deactivated {\n  background: var(--inputs-disable-disable-surface);\n}\n\n.equipmentTitle {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  column-gap: 5px;\n}\n\n.equipmentItemName {\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 14px;\n  color: var(--tables-primary-row-text-main);\n  margin-bottom: 15px;\n  text-transform: uppercase;\n  text-decoration: none;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -moz-box;\n  -moz-box-orient: vertical;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  line-clamp: 2;\n  box-orient: vertical;\n  min-height: 34px;\n  cursor: pointer;\n}\n\n.equipmentItemSensors {\n  width: 100%;\n  min-height: 37px;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 5px;\n  position: relative;\n  margin-bottom: auto;\n}\n\n.equipmentItemInfo {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-end;\n  margin-top: 15px;\n}\n\n.equipmentItemInfoAi {\n  font-size: 11px;\n  line-height: 14px;\n  color: var(--tables-secondary-row-sub-title-text);\n  display: flex;\n  align-items: flex-end;\n  text-transform: uppercase;\n  gap: 5px;\n}\n\n.linkDetails {\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 14px;\n  color: var(--buttons-surface);\n  text-decoration: none;\n  text-transform: uppercase;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"equipmentItem": `equipmentItem__iMQDY`,
	"deactivated": `deactivated__Ryvix`,
	"equipmentTitle": `equipmentTitle__HXGbI`,
	"equipmentItemName": `equipmentItemName__da7Uo`,
	"equipmentItemSensors": `equipmentItemSensors__jtP2K`,
	"equipmentItemInfo": `equipmentItemInfo__HvCXT`,
	"equipmentItemInfoAi": `equipmentItemInfoAi__nrNvc`,
	"linkDetails": `linkDetails__m5p6V`
};
module.exports = ___CSS_LOADER_EXPORT___;
